import { SseSocket } from "../providers/socket/sseClient";
import { SocketIoSocket } from "../providers/socket/socketIoClient";
import { RealtimeSocket } from "../providers/socket/types";
import { getSessionAccessToken } from "../services/sessionToken";

export type { RealtimeSocket } from "../providers/socket/types";

let socket: RealtimeSocket | null = null;

const apiBaseUrl = process.env.REACT_APP_API_URL;
const realtimeTransport = ( process.env.REACT_APP_REALTIME_TRANSPORT ?? "sse" ).trim().toLowerCase();

export const buildSseRealtimeUrl = ( apiUrl: string, organizationId: string, userId: string, accessToken?: string ) => {
  const sanitizedApiUrl = apiUrl.trim().replace(/\/+$/, "");
  const sanitizedOrganizationId = organizationId.trim();
  const sanitizedUserId = userId.trim();

  if ( !sanitizedApiUrl ) {
    throw new Error("REACT_APP_API_URL nao configurada para realtime SSE.");
  }
  if ( !sanitizedOrganizationId ) {
    throw new Error("organizationId obrigatorio para realtime SSE.");
  }
  if ( !sanitizedUserId ) {
    throw new Error("userId obrigatorio para realtime SSE.");
  }

  const query = new URLSearchParams({
    userId: sanitizedUserId,
  });
  const sanitizedAccessToken = accessToken?.trim();
  if ( sanitizedAccessToken ) query.set("token", sanitizedAccessToken);

  return `${ sanitizedApiUrl }/realtime/organization-${ encodeURIComponent( sanitizedOrganizationId ) }?${ query.toString() }`;
};

export const connectSocket = ( organizationId: string, userId: string ): RealtimeSocket => {
  if ( !socket || socket.disconnected ) {
    const namespace = `/organization-${ organizationId }`;

    if ( realtimeTransport === "socketio" ) {
      socket = new SocketIoSocket(`${ apiBaseUrl }${ namespace }`, userId);
    } else {
      socket = new SseSocket( buildSseRealtimeUrl( apiBaseUrl ?? "", organizationId, userId, getSessionAccessToken()));
    }
  }

  return socket;
};

export const getSocket = (): RealtimeSocket => {
  if ( !socket ) {
    throw new Error("Realtime nao inicializado. Use connectSocket primeiro.");
  }

  return socket;
};

export const disconnectSocket = () => {
  if ( socket ) {
    socket.disconnect();
    socket = null;
  }
};
